import './index.css';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { App } from './App';
import { KatoProvider } from './contexts/KatoContext';
import { ModulesProvider } from './contexts/ModulesContext';
import { UserProvider } from './contexts/UserContext';
import { YearProvider } from './contexts/YearContext';
import { KeycloakProvider } from './keycloak/KeycloakProvider';
import './i18n';

const container = document.getElementById('root');
if (!container) {
  throw new Error('Корневой элемент #root не найден в index.html');
}
createRoot(container).render(
  <KeycloakProvider>
    <UserProvider>
      <ModulesProvider>
        <KatoProvider>
          <YearProvider>
            <BrowserRouter>
              <App />
            </BrowserRouter>
          </YearProvider>
        </KatoProvider>
      </ModulesProvider>
    </UserProvider>
  </KeycloakProvider>,
);
